export enum FloatingAdminToolsEvents {
  ADMIN_TOOLS_TOGGLED = "AdminToolsToggled",
  POINT_HOVER = "PointHover",
  CLICK_ASSET_WITH_TOOL_SHOWING = "ClickAssetWithToolsShowing"
}